import React, { Component } from 'react';
import TagsInput from 'react-tagsinput'
import Loading from '../components/loading';
import fetcher from '../API';
import { message, Table, Space, Button, Tag, Typography, Modal as AntModal, Descriptions, Tooltip, Badge } from 'antd';
import 'react-tagsinput/react-tagsinput.css';
import Modal from './Modal'
import moment from 'moment-timezone';
import ProductSKUTag from './ProductSKUTag';
import { submitOrder } from '../services/orderService';
import { ADDRESS_TEMPLATES, getForwardAddress } from '../common/forwardAddressProvider';
import { EditOutlined, QuestionOutlined } from '@ant-design/icons';
import { Decimal } from 'decimal.js'
const { Text, Link } = Typography;

// deprecated: White List Merchants to check if sku.onHand should be displayed
const tipStyle = { backgroundColor: '#faad14', padding: 1, borderRadius: '50%', color: '#fff' }
const credibleMerchants = [
    'moosejaw', 'patmcgrath', 'hbx', 'zappos', 'lussoitaliano',
    'samsclub', 'peterthomasroth', 'harrods', 'matchesfashion', 'lindasstuff',
    'winkylux', '6pm', 'dimmak', '100percentpure', 'superheroic',
    'churchs', 'senreve', 'shopbop', 'mnml', 'ripndip',
    'ancientnutrition', 'urbanoutfitters', 'harveynichols', 'bluemercury', 'mansurgavriel',
    'coltorti', 'neimanmarcus', 'mountainsteals', 'hourglass', 'yoox',
    'michaelkors', 'finishline', 'bhfo', 'modaoperandi', 'madaluxe', 'rencleanskincare',
    'juicebeauty', 'carters', 'shoppremiumoutlets', 'mountainsteals', 'baseblu', 'ashford',
    'ruelala', 'saksfifthavenue', 'slamjam'
]

function fetchOnhands(productId, callback) {
    fetcher
        .get(`api/v1/_internal/inventory/onhand/${productId}`)
        .then(response => {
            if (callback) {
                callback(response);
            }
        })
}

function fetchUnavailableSkus(productId, callback) {
    fetcher
        .get(`api/v1/products/${productId}/_internal?allSku=true&pinInfo=true&img=true`)
        .then(response => {
            if (callback) {
                callback(response);
            }
        })
}

function fetchSkuWeight(productId) {
    return fetcher.get(`/api/v1/_internal/weight/explain/source/${productId}`);
}

class ProductSKUList extends Component {

    componentDidMount() {
        // fetch and refresh onhand data
        fetchOnhands(this.props.productId, (response) => {
            this.setState({ onhand: response.data })
        });

        fetchUnavailableSkus(this.props.productId, (response) => {
            this.setState({
                unavailableSkus: response.data.unavailableSkus || [],
                pinInfos: response.data.pinInfos || []
            });
        });

        fetchSkuWeight(this.props.productId).then(res => {
            this.setState({
                weightMap: res.data
            })
        })

        this.scrollToHashId();
    }

    // emulate URL anchor page scroll functionality
    scrollToHashId() {
        // get URL hash (minus the hash mark)
        const hash = window.location.hash.substring(1)

        // if there's a hash, scroll to that ID
        if (hash && hash.length) {
            // setTimeout and requestAnimationFrame help ensure a true DOM repaint/reflow before we try to scroll
            // - reference: http://stackoverflow.com/a/34999925
            setTimeout(
                window.requestAnimationFrame(function () {
                    const el = document.getElementsById(hash)
                    el.scrollIntoView()
                }),
                0
            )
        }
    }

    state = {
        isEditing: false,
        tags: [],
        checkedSKUList: [],
        isLoading: false,
        onhand: {},
        editingSKU: {
            skuId: '',
            stock: 0
        },
        pinInfos: [],
        unavailableSkus: [],
        comment: '', // pin/unpin描述
        duration: '', // pin/unpin时间
        weightMap: {},
        address: 0,
        pinDialogVisible: false,
        orderDialogVisible: false,
        cents: '',
        quantityPerOrder: '',
        orderCount: ''
    }

    generateSKU = (sku, productId) => {
        return 'SKU-' + (sku?.productId || productId) + '-' + sku?.id;
    }

    listUpSKUAttributes = (sku, productInfo) => {
        const { colors, sizes } = productInfo;
        const color = colors?.find(color => color?.name === sku?.color?.name);
        const size = sizes?.find(size => size.name === sku?.size?.name);
        const colorName = color?.displayText;
        const sizeName = size?.label || size?.displayName;
        let attributes = [];
        if (sku.color && sku.color.name) {
            attributes.push(
                <React.Fragment key='color'>
                    <div style={{textAlign: 'left'}}>
                        <Text strong>color: </Text>
                        <span>{`${colorName ? colorName + '｜' : ''}${sku.color.name}`}</span>
                    </div>
                </React.Fragment>
            );
        }
        if (sku.size && sku.size.name) {
            attributes.push(
                <React.Fragment key='size'>
                    <div style={{textAlign: 'left'}}>
                        <Text strong>size: </Text>
                        <span>{`${sizeName ? sizeName + '｜' : ''}${sku.size.name}`}</span>
                    </div>
                </React.Fragment>
            );
        }

        return attributes;
    }

    handleTagsInputChange = (tags) => {
        this.setState({ tags })
    }

    handleAllSKUCheckboxChange = (event) => {
        const { skus } = this.props || {};
        let checkedSKUList = [];
        if (event.target.checked) {
            for (let i = 0; i < skus.length; i++) {
                checkedSKUList.push(i);
            }
        }
        this.setState({ checkedSKUList });
    }

    handleSKUCheckboxChange = (indexArr, event) => {
        this.setState({ checkedSKUList: indexArr });
    }

    handleTagEditClick = () => {
        this.setState({ isEditing: true });
    }

    handleCancelBtnClick = () => {
        this.setState({ isEditing: false, tags: [] });
    }

    handleClearAllTagsBtnClick = () => {
        // iterating all the skus and set the replace to empty array, so all the tags
        // for every sku will be removed
        const { skus } = this.props || {}
        if (!skus || skus.length === 0) {
            // do nothing if skus is empty or not existing
            return;
        }

        const skuTags = skus.map((s) => {
            return { sku: s, replace: [] }
        });

        this.updateSKUTags(skuTags);
    }

    handleDeleteTagForSKU = (index, tag) => {
        const { skus } = this.props || {};
        const sku = skus[index];
        const skuTags = [
            {
                sku: sku,
                remove: [tag]
            }
        ]
        this.updateSKUTags(skuTags);
    }
    // pin or unpin sku
    pinSku(unavailableSkus, sku, isPin = null) {
        let { comment, duration } = this.state
        const inv = unavailableSkus && unavailableSkus.length ? unavailableSkus.includes(sku) : false;
        let inventoryText = inv ? 'UNAVAILABLE' : 'AVAILABLE';
        this.props.pinSku(sku.productId || this.props.productId, inventoryText, [sku.id], isPin, comment, duration)
    }

    // submit order 
    clickSubmitOrder = (skuIdFull, skuInfo) => {
        let { cents, quantityPerOrder, orderCount } = this.state
        const str = /^[0-9]*[1-9][0-9]*$/
        if (!str.test(parseInt(cents || skuInfo['cents']))) {
            return message.error("Cents输入错误");
        }
        if (!str.test(parseInt(quantityPerOrder))) {
            return message.error("Quantity per order输入错误");
        }
        if (!str.test(parseInt(orderCount))) {
            return message.error("Order Count输入错误");
        }
        this.submitOrder(1, skuIdFull, skuInfo)
    }

    submitOrder(count, skuIdFull, skuInfo) {
        let { cents, quantityPerOrder, orderCount, address } = this.state
        let { productInfo } = this.props;
        const  groupInfo = {
            shippingAddress: getForwardAddress(productInfo?.merchantId, address)
        }
        submitOrder(
            skuIdFull,
            parseInt(cents || skuInfo['cents']),
            parseInt(quantityPerOrder),
            skuInfo,
            productInfo,
            count,
            groupInfo
        ).then(res => {
                count += 1
                if (count <= parseInt(orderCount)) {
                    this.submitOrder(count, skuIdFull, skuInfo)
                } else {
                    this.clearOrderDialog();
                    this.setState({orderDialogVisible: false});
                    window.alert(`已提交${orderCount}单，成功${count - 1}单`)
                }
            })
            .catch(err => {
                this.clearOrderDialog();
                this.setState({orderDialogVisible: false});
                if (count > 1) {
                    window.alert(`已提交${orderCount}单，成功${count}单`);
                } else {
                    window.alert("提交失败");
                }
            })
    }
    handleSaveBtnClick = () => {
        const { skus } = this.props || {};
        if (!skus || skus.length === 0) {
            // do nothing if skus is empty or not existing
            message.error("This product don't have SKU.");
            return;
        }
        const { checkedSKUList, tags } = this.state || {};
        if (!checkedSKUList || checkedSKUList.length === 0) {
            // do nothing if no sku is checked
            message.error("Please at least check one SKU before save.");
            return;
        }

        if (!tags || tags.length === 0) {
            // do nothing if tags is empty
            message.error("Please at least input one tags before save.");
            return;
        }

        const skuTags = checkedSKUList.map(index => {
            const s = skus[index];
            return { sku: s, add: tags }
        });

        this.updateSKUTags(skuTags);
    }

    /**
   * send request to update tags on SKU level
   * skuTags: list of the sku + tags
   *
   * FYI: https://github.com/borderxlab/pacemaker/issues/2749
   */
    updateSKUTags = (skuTags) => {
        this.setState({ isLoading: true });
        fetcher
            .patch(`api/v1/products/${this.props.productId}/skus/_batch/tags`, skuTags)
            .then((responese) => {
                if (this.props.refreshProductInfo) {
                    // update the product info
                    this
                        .props
                        .refreshProductInfo();
                }
                this.setState({ isLoading: false, isEditing: false, checkedSKUList: [] });
                message.success("SKU tags update succeed");
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                message.error(error.toString());
            });
    }

    renderTagsForSKU = (skuIndex, tags) => {
        if (!tags) {
            return null;
        }
        const tagsComponents = tags.map(tag => {
            return (<ProductSKUTag
                key={skuIndex + tag}
                tag={tag}
                index={skuIndex}
                onClickDelete={this.handleDeleteTagForSKU} />)
        });
        return tagsComponents;
    }

    onSkuStockChange = (e) => {
        const stock = parseInt(e.target.value);
        const editingSKU = this.state.editingSKU;
        editingSKU.stock = stock;
        this.setState({ editingSKU });
    }

    saveOnhands = () => {
        fetcher.post('api/v1/_internal/inventory/onhand', {
            skuId: this.state.editingSKU.skuId,
            stockCount: this.state.editingSKU.stock,
            productId: this.props.productId
        }).then(response => {
            message.success('保存成功');
        }).catch(error => {
            message.error(error);
        });
    }

    renderInventoryStatus = (productId, sku, pinInfos, unavailableSkus) => {

        const pinSkuFormat = productId + '/' + sku.id;

        let pinedSku;
        if (pinInfos && pinInfos.length) {

            pinedSku = pinInfos.find((item, index) => {
                return item.name == pinSkuFormat;
            });
        }

        let unavailableReason;
        if (sku &&
            sku.attributes &&
            sku.attributes.attributes &&
            sku.attributes.attributes.status_description &&
            sku.attributes.attributes.status_description.choices &&
            sku.attributes.attributes.status_description.choices.length) {
            unavailableReason = `(${sku.attributes.attributes.status_description.choices})`;
        }

        return (
            <React.Fragment>
                <Space direction="vertical">
                    {unavailableSkus?.includes(sku) ? <Tag color="red">UNAVAILABLE</Tag> : <Tag color="blue">AVAILABLE</Tag>}
                    <div className='badge badge-warning' style={{whiteSpace: 'normal'}}>
                        {pinedSku ? `Pined To ${moment(pinedSku.expiredAt).format('YYYY/MM/DD HH:mm')}` : null}
                    </div>
                    <div>{unavailableReason}</div>
                </Space>
            </React.Fragment>
        );
    }
    getPinedStatus = (productId, sku, pinInfos) => {
        const pinSkuFormat = productId + '/' + sku.id;
        let pinedSku;
        if (pinInfos && pinInfos.length) {
            pinedSku = pinInfos.find((item, index) => {
                return item.name == pinSkuFormat;
            });
            if (pinedSku) return true
        }
        return false
    }

    isShowSkuOnHand = (sku) => {
        if (this.props.merchantInfo?.integration === 'SHOPIFY') {
            return true
        }
        const isStockQtyAvailable = sku.attributes?.attributes?._intl_raw_stock_qty?.choices?.length
        if (!!isStockQtyAvailable) {
            return true
        }
        const productId = sku.productId
        if (!productId) return false
        const merchant = productId.split('_')[0]
        return credibleMerchants.indexOf(merchant) !== -1
    }

    showOnHands = (sku) => {
        if (sku.attributes && sku.attributes.attributes && sku.attributes.attributes.sku_operation_hand && sku.attributes.attributes.sku_operation_hand.choices[0]) {
            return sku.attributes.attributes.sku_operation_hand.choices[0]
        }
        if (this.isShowSkuOnHand(sku)) {
            return sku.onHand || '-'
        }
        return '-'
    }

    renderPinSkuModal = () => {
        const { unavailableSkus, comment, duration } = this.state || {};
        const { choosedSku, pinedStatus, pinDialogVisible } = this.state;
        return (
            <AntModal
                visible={pinDialogVisible}
                title="Complete Infomation"
                okText={pinedStatus ? 'UNPIN' : 'PIN'}
                onOk={() => {
                    this.pinSku(unavailableSkus, choosedSku, !pinedStatus);
                    this.setState({pinDialogVisible: false});
                    this.clearPinDialog();
                }}
                onCancel={() => {
                    this.setState({pinDialogVisible: false});
                    this.clearPinDialog();
                }}
            >
                <div>
                    comment:
                    <input type="text"
                        className="form-control"
                        aria-label="comment"
                        value={comment}
                        onChange={(e) => this.setState({ comment: e.target.value })}></input>
                </div>
                <div>
                    duration:(后缀应当以d,h,m,s中的一种为时间单位)
                    <input type="text"
                        className="form-control"
                        aria-label="duration"
                        value={duration}
                        onChange={(e) => this.setState({ duration: e.target.value })}></input>

                </div>
            </AntModal>
        )
    }

    clearPinDialog = () => {
        this.setState({
            comment: '',
            duration: ''
        })
    }

    renderOrderModal = () => {
        const { productId } = this.props;
        const { choosedSku, orderDialogVisible, cents, quantityPerOrder, orderCount, address } = this.state;
        const skuIdFull = this.generateSKU(choosedSku, productId);
        return (
            <AntModal
                visible={orderDialogVisible}
                title="Complete Infomation"
                onOk={() => this.clickSubmitOrder(skuIdFull, choosedSku)}
                onCancel={() => {
                    this.setState({orderDialogVisible: false});
                    this.clearOrderDialog();
                }}
            >
                <div>
                    Order Item:{skuIdFull}
                </div>
                <div>
                    Cents(单件价：美分):
                    <input type="text"
                        className="form-control"
                        aria-label="comment"
                        value={cents}
                        onChange={(e) => this.setState({ cents: e.target.value })}></input>
                </div>
                <div>
                    Quantity per order(每单下几件):
                    <input type="text"
                        className="form-control"
                        aria-label="duration"
                        value={quantityPerOrder}
                        onChange={(e) => this.setState({ quantityPerOrder: e.target.value })}></input>

                </div>
                <div>
                    Order Count(下几单):
                    <input type="text"
                        className="form-control"
                        aria-label="comment"
                        value={orderCount}
                        onChange={(e) => this.setState({ orderCount: e.target.value })}></input>
                </div>
                <div>
                    Address(地址):
                    <select
                        className="form-control"
                        onChange={(e) => this.setState({ address: e.target.value })}
                        value={address}
                    >
                        {ADDRESS_TEMPLATES.map((item, index) => {
                            return <option key={index} value={index}>{`${item.country} ${item.state} ${item.city} ${item.line1} ${item.line2}`}</option>
                        })}
                    </select>
                </div>
            </AntModal>
        )
    }

    clearOrderDialog = () => {
        this.setState({
            cents: '',
            quantityPerOrder: '',
            orderCount: '',
            address: 0
        })
    }

    renderSkuPrice = (row, priceStr) => {
        if(!priceStr) { return null }
        const price = priceStr.slice(1)
        const choices = row?.sku?.attributes?.attributes?._intl_official_cents?.choices
        if(choices?.length) {
            const origin = new Decimal(choices[0]).div(new Decimal(100))
            const diff = new Decimal(price).sub(origin)
            return (
                <Descriptions bordered column={1} size="small">
                    <Descriptions.Item label="原始价格">{`$${origin.toNumber()}`}</Descriptions.Item>
                    <Descriptions.Item label="销售价格:">{priceStr}</Descriptions.Item>
                    <Descriptions.Item label={
                        <Tooltip placement="topLeft" title="预期改价幅度未计算折扣活动逻辑">
                            改价幅度
                            {/* <Avatar gap={1} style={{marginTop: -3}} size={15} icon={<QuestionOutlined />} ></Avatar>  */}
                            <Badge count={<QuestionOutlined />} style={tipStyle}  />
                        </Tooltip>
                    }>{`$${diff.toNumber()}`}</Descriptions.Item>
                </Descriptions>
            )
        }
        return price
    }

    render() {
        const { skus = [], productId, productInfo } = this.props || {};
        const {
            isEditing,
            tags,
            isLoading,
            unavailableSkus,
            pinInfos,
            weightMap
        } = this.state || {};
        let dataSource = [];
        const columns = [{
            title: 'SKU',
            dataIndex: 'skuId',
            key: 'skuId',
            width: 170,
            fixed: 'left',
            align: 'center',
            render: (text, record) => <Space direction="vertical">
                {record?.sku?.images?.[0]?.full?.url && <img className="thumbnail-img" src={record?.sku?.images?.[0]?.full?.url} />}
                <Link href={record?.skuLink} target="_blank">
                    {text}
                </Link>
            </Space>
        }, {
            title: 'Inventory',
            dataIndex: 'inventory',
            key: 'inventory',
            align: 'center',
            width: 130,
        }, {
            title: 'Onhand',
            dataIndex: 'onHand',
            key: 'onHand',
            align: 'center',
            width: 90,
        }, {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            align: 'center',
            width: 240,
            render:(price, row) => this.renderSkuPrice(row, price)
        }, {
            title: 'Weight (lb)',
            dataIndex: 'weight',
            key: 'weight',
            align: 'center',
            width: 120,
            render: (text) => {
                return (
                    <Space direction="vertical">
                        {text && text.ACCURATE && <div>accurate: {text.ACCURATE}</div>}
                        {text && text.LOGISTIC && <div>logistic: {text.LOGISTIC}</div>}
                    </Space>
                )
            }
        }, {
            title: 'Attributes',
            dataIndex: 'attributes',
            key: 'attributes',
            align: 'center',
            width: 150,
            render: (text) => <Space direction="vertical">{text}</Space>
        }, {
            title: <Space onClick={this.handleTagEditClick} style={{cursor: 'pointer'}}>tag<EditOutlined /></Space>,
            dataIndex: 'tags',
            key: 'tags',
            align: 'center',
            width: 150,
            render: (text) => <Space direction="vertical">{text}</Space>
        }, {
            title: 'Operations',
            dataIndex: 'operations',
            key: 'operations',
            align: 'center',
            width: 150,
            fixed: 'right',
            render: (text, record) => {
                return (
                    <Space direction="vertical">
                        <Button
                            ghost
                            style={{width: '90px'}}
                            type="primary"
                            danger
                            onClick={() => {
                                this.setState({
                                    pinDialogVisible: true,
                                    choosedSku: record.sku,
                                    pinedStatus: record?.pinedStatus
                                })
                            }}
                        >
                            {record?.pinedStatus ? 'UNPIN' : 'PIN'}
                        </Button>
                        <Button
                            ghost
                            style={{width: '90px'}}
                            type="primary"
                            onClick={() => {
                                this.setState({
                                    orderDialogVisible: true,
                                    choosedSku: record.sku,
                                    cents: record.sku.cents
                                })
                            }}
                        >
                            Order
                        </Button>
                    </Space>
                )
            }
        }]

        const allSkus = skus.concat(unavailableSkus || []);
        if (allSkus) {
            for (let index = 0; index < allSkus.length; index++) {
                const sku = allSkus[index];
                const tags = this.renderTagsForSKU(index, sku.tags);
                const skuIdFull = this.generateSKU(sku, productId);
                const onhand = this.state.onhand[skuIdFull]
                    ? this.state.onhand[skuIdFull].stock
                    : '';
                const remainStock = this.state.onhand[skuIdFull]
                    ? this.state.onhand[skuIdFull].remainderStock
                    : '';
                const weight = weightMap?.[skuIdFull]?.weight || {};

                const onHandEditor = <EditOutlined
                    data-toggle="modal"
                    data-target="#onhandEditModal"
                    onClick={() => {
                        this.setState((prevState) => {
                            const editingSKU = {
                                skuId: prevState?.onhand?.[skuIdFull]?.skuId,
                                stock: prevState?.onhand?.[skuIdFull]?.stock
                            };
                            return { editingSKU }
                        })
                    }} />
                const salesHistoryLink = () => {
                    let end = moment().utc().format('YYYY-MM-DD')
                    let start = moment().subtract(60, 'days').utc().format('YYYY-MM-DD')
                    let color = (sku.color && sku.color.name) ? sku.color.name : ""
                    let size = (sku.size && sku.size.name) ? sku.size.name : ""
                    return `https://plutus.bybieyang.com/dashboard/509?start_date=${start}&end_date=${end}&productid=${productId}&color=${color}&size=${size}`
                }
                dataSource.push({
                    key: index,
                    sku: sku,
                    skuId: skuIdFull,
                    inventory: this.renderInventoryStatus(productId, sku, pinInfos, unavailableSkus),
                    price: '$' + sku.cents / 100.0,
                    weight: weight,
                    attributes: this.listUpSKUAttributes(sku, productInfo),
                    tags: tags,
                    pinedStatus: this.getPinedStatus(productId, sku, pinInfos),
                    skuLink: salesHistoryLink(),
                    onHand: this.props.isSelfSale ? (
                        <div>
                            {remainStock && onhand ? `${remainStock}/${onhand}` : ''} {onHandEditor}
                        </div>
                    ) : <div>{this.showOnHands(sku)}</div>
                })
            }
        }

        let editTagsComponent;
        if (isEditing === true) {
            editTagsComponent = (
                <tr key='tagsinput'>
                    <td colSpan={1} />
                    <td colSpan={3}>
                        <TagsInput value={tags} onChange={this.handleTagsInputChange} />
                        <div className="d-flex my-2">
                            <button
                                type="button"
                                onClick={this.handleCancelBtnClick}
                                className="btn btn-secondary mr-2">
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={this.handleSaveBtnClick}
                                className="btn btn-info">Save</button>
                            <button
                                type="button"
                                className="btn btn-outline-danger ml-auto"
                                data-toggle="modal"
                                data-target="#clearAllTagsModal">
                                Clear all sku tags
                            </button>
                        </div>
                    </td>
                </tr>
            )
        }

        const clearSkuModalFooter = (
            <div>
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button
                    type="button"
                    className="btn btn-danger ml-2"
                    data-dismiss="modal"
                    onClick={this.handleClearAllTagsBtnClick}>
                    Clear all sku tags
                </button>
            </div>
        )

        const clearSkuModalBody = (
            <div>
                All the tags for all the SKU will be removed, are your sure?
                <br />
                所有SKU的TAG都会被删除，你确定要删除吗？
            </div>
        )

        const clearAllTagsModal = <Modal
            id="clearAllTagsModal"
            header={{
                title: "Remove All Tags"
            }}
            body={clearSkuModalBody}
            footer={clearSkuModalFooter} />

        const onhandEditBody = (
            <div>
                <h5>{this.state.editingSKU.skuId}</h5>
                <input
                    type="number"
                    className="form-control"
                    value={this.state.editingSKU.stock}
                    onChange={this.onSkuStockChange} />
            </div>
        );

        const onhandEditFooter = (
            <div>
                <button className="btn btn-info"
                    onClick={this.saveOnhands}
                    data-dismiss="modal">save</button>
            </div>
        );

        const onhandEditModal = <Modal
            id="onhandEditModal"
            header={{
                title: "库存编辑器"
            }}
            body={onhandEditBody}
            footer={onhandEditFooter} />

        return (
            <div className="table-responsive" style={{
                position: 'relative'
            }}>
                {clearAllTagsModal}
                {onhandEditModal}
                {isLoading && <Loading spinning className='bg-loading' />}
                {editTagsComponent}
                <Table
                    rowSelection={isEditing ? {
                        type: 'checkbox',
                        selectedRowKeys: this.state.checkedSKUList,
                        onChange: this.handleSKUCheckboxChange
                    } : null}
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{x: '100%'}}
                    pagination={false}
                    
                />
                {this.renderPinSkuModal()}
                {this.renderOrderModal()}
            </div>
        )
    }
}

export default ProductSKUList;
